import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { basename } from 'vscode/vscode/vs/base/common/path';
import { isWindows } from 'vscode/vscode/vs/base/common/platform';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IExtensionManagementService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { NeverShowAgainScope } from 'vscode/vscode/vs/platform/notification/common/notification';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { InstallRecommendedExtensionAction } from 'vscode/vscode/vs/workbench/contrib/extensions/browser/extensionsActions';
import { ITerminalService } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal.service';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

const _moduleId = "vs/workbench/contrib/terminal/browser/terminalWslRecommendationContribution";
let TerminalWslRecommendationContribution = class TerminalWslRecommendationContribution extends Disposable {
    static { this.ID = 'terminalWslRecommendation'; }
    constructor(instantiationService, productService, notificationService, extensionManagementService, terminalService) {
        super();
        if (!isWindows) {
            return;
        }
        const exeBasedExtensionTips = productService.exeBasedExtensionTips;
        if (!exeBasedExtensionTips || !exeBasedExtensionTips.wsl) {
            return;
        }
        let listener = terminalService.onDidCreateInstance(async (instance) => {
            async function isExtensionInstalled(id) {
                const extensions = await extensionManagementService.getInstalled();
                return (
                     (extensions.some(e => e.identifier.id === id))
                );
            }
            if (!instance.shellLaunchConfig.executable || basename(instance.shellLaunchConfig.executable).toLowerCase() !== 'wsl.exe') {
                return;
            }
            listener?.dispose();
            listener = undefined;
            const extId = ( (Object.keys(exeBasedExtensionTips.wsl.recommendations))).find(extId => exeBasedExtensionTips.wsl.recommendations[extId].important);
            if (!extId || (await isExtensionInstalled(extId))) {
                return;
            }
            notificationService.prompt(Severity$1.Info, ( localizeWithPath(
                _moduleId,
                0,
                "The '{0}' extension is recommended for opening a terminal in WSL.",
                exeBasedExtensionTips.wsl.friendlyName
            )), [
                {
                    label: ( localizeWithPath(_moduleId, 1, 'Install')),
                    run: () => {
                        instantiationService.createInstance(InstallRecommendedExtensionAction, extId).run();
                    }
                }
            ], {
                sticky: true,
                neverShowAgain: { id: 'terminalConfigHelper/launchRecommendationsIgnore', scope: NeverShowAgainScope.APPLICATION },
                onCancel: () => { }
            });
        });
    }
};
TerminalWslRecommendationContribution = ( (__decorate([
    ( (__param(0, IInstantiationService))),
    ( (__param(1, IProductService))),
    ( (__param(2, INotificationService))),
    ( (__param(3, IExtensionManagementService))),
    ( (__param(4, ITerminalService)))
], TerminalWslRecommendationContribution)));

export { TerminalWslRecommendationContribution };
